import { getFetch } from "../../utils/fetch";

async function getMachineData(term) {
  const data = await getFetch(`/ReportWeb/Machines?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getMachineData };
